export default __webpack_public_path__ + "static/media/GOOGLE.298a621b.png";